import MEDIA from '../constants/cultureMedia.json';

/*
 * The four standard culture media (migration 0084; the server's
 * routes/culture_media.py, pinned to constants/cultureMedia.json by
 * test_culture_media.py). Wherever a medium is chosen they come first, and
 * are what the picker offers by default; the lab's other media follow.
 */
export const PRESETS = MEDIA.presets;
export const PRESET_NAMES = PRESETS.map((p) => p.name);

const key = (name) => String(name || '').trim().toLowerCase();

export function isPreset(name) {
  return PRESET_NAMES.some((p) => key(p) === key(name));
}

/** The lab's media that are not one of the four, each once, in their order. */
export function otherMedia(protocols) {
  const seen = new Set(PRESET_NAMES.map(key));
  return (protocols || []).filter((p) => {
    const k = key(p?.name ?? p);
    if (!k || seen.has(k)) return false;
    seen.add(k);
    return true;
  });
}

/**
 * A field isolation's medium and antibiotics (routes/field_isolation.py) as
 * the name a plate takes: one of the four when it is one, else the base and
 * its antibiotics -- culture_media.medium_name in the browser.
 */
export function mediumName(base, antibiotics = []) {
  if (!base) return '';
  const wanted = [...(antibiotics || [])].sort().join('|');
  const found = PRESETS.find((p) => p.base === String(base).toUpperCase()
    && [...p.antibiotics].sort().join('|') === wanted);
  return found ? found.name : [base, ...(antibiotics || [])].join(' + ');
}

/** The (base, antibiotics) a standard medium is made of, or null. */
export function presetParts(name) {
  const found = PRESETS.find((p) => key(p.name) === key(name));
  return found ? { base: found.base, antibiotics: [...found.antibiotics] } : null;
}
